import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Typography,
  IconButton,
} from "@material-ui/core";
import {
  Close as CloseIcon,
  SettingsOutlined as SettingsOutlinedIcon,
} from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { toggleFlag } from "@store";
import { Form } from "@components";
import { Settings } from "./settings";
import { AddDelegate } from "./add-delegate";
import { Delegates } from "./delegates";

type Props = {
  open: boolean;
};

export const SettingsModal: React.FC<Props> = ({ open }) => {
  const storeDispatch = useDispatch();

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={() => storeDispatch(toggleFlag("SETTINGS_MODAL_OPEN", false))}
      open={open}
      scroll="body"
    >
      <DialogTitle disableTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Box display="flex" flexGrow={1}>
                <SettingsOutlinedIcon />
                <Typography component={Box} pl={1}>
                  Settings
                </Typography>
              </Box>
              <Box display="flex" pl={1} marginX="-9px" marginY="-3px">
                <IconButton
                  size="small"
                  onClick={() =>
                    storeDispatch(toggleFlag("SETTINGS_MODAL_OPEN", false))
                  }
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Form>
          <Form.Title>1- Google Chat</Form.Title>
          <Settings />
          <Form.Title>2- Edit Delegates</Form.Title>
          <AddDelegate />
          <Delegates />
        </Form>
      </DialogContent>
    </Dialog>
  );
};
